module.exports = __webpack_public_path__ + "static/media/loginImage.1d9996f2.png";